import React, { useState, useRef } from 'react'
import PageLayout from '@layouts/PageLayout'
import { useLocalization } from '@contexts/LocalizationContext'
import { Button, Input, Table } from 'antd'
import Fetch from '@components/CRUD/Fetch'

import { useParams } from 'react-router-dom'
import { client } from '@utils/client'
import moment from 'moment'

const CodeDetail = () => {
  const { t } = useLocalization()
  const defaultPage = 1
  const defaultPageSize = 10
  const fetchRef = useRef(null)
  const [page, setpage] = useState(defaultPage)
  const [pageSize, setpageSize] = useState(defaultPageSize)
  const [shopName, setShopName] = useState('')
  const params = useParams()

  const fetch = async ({ page, pageSize }) => {
    const result = await client
      .get(`/reward/${params.id}/redemption`, {
        params: {
          page: page,
          limit: pageSize,
          // keyword: 'test',
        },
      })
      .then((res) => res.data)

    if (result.data.length > 0) {
      const resultShop = await client
        .get(`shop/${result.data[0].reward.shopId}`)
        .then((res) => res.data)

      setShopName(resultShop.name)
    }

    return result
  }

  const columns = [
    {
      title: t('rewards.list.codeDetail.column.no'),
      // dataIndex: 'no',
      key: 'no',
      width: 50,
      render: function no(_text, _record, index) {
        return <p>{pageSize * (page - 1) + index + 1}</p>
      },
    },
    {
      title: t('rewards.list.codeDetail.column.code'),
      dataIndex: 'code',
      key: 'code',
      width: 150,
    },
    {
      title: t('rewards.list.codeDetail.column.status'),
      dataIndex: 'reward',
      key: 'usableStatus',
      width: 150,
      render: function usableStatus(rowData) {
        let color = ''
        let text = ''
        if (rowData.usableStatus === 'available') {
          //available
          color = '#5BBD94'
          text = 'ใช้งานได้'
        } else if (rowData.usableStatus === 'unavailable') {
          color = '#818181'
          text = 'ใช้แล้ว'
        } else if (rowData.usableStatus === 'expired') {
          color = '#D5462D'
          text = 'หมดอายุแล้ว'
        }
        return <p style={{ color: color, fontWeight: 'bold' }}>{text}</p>
      },
    },
    {
      title: t('rewards.list.codeDetail.column.createdAtDate'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 150,
      render: function date(createdAt) {
        if (createdAt) {
          return moment(createdAt).format('YYYY-MM-DD')
        }
        return t('rewards.list.codeDetail.column.NotCreatedAtDate')
      },
    },
    {
      title: t('rewards.list.codeDetail.column.createdAtTime'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 150,
      render: function date(createdAt) {
        if (createdAt) {
          return moment(createdAt).format('HH:mm:ss')
        }
        return t('rewards.list.codeDetail.column.NotCreatedAtDate')
      },
    },
    {
      title: t('rewards.list.codeDetail.column.usedDate'),
      dataIndex: 'usedDate',
      key: 'usedDate',
      width: 150,
      render: function date(usedDate) {
        if (usedDate) {
          return moment(usedDate).format('YYYY-MM-DD')
        }
        return t('rewards.list.codeDetail.column.NotusedTime')
      },
    },
    {
      title: t('rewards.list.codeDetail.column.usedTime'),
      dataIndex: 'usedDate',
      key: 'usedDate',
      width: '40%',
      render: function date(usedDate) {
        if (usedDate) {
          return moment(usedDate).format('HH:mm:ss')
        }
        return t('rewards.list.codeDetail.column.NotusedTime')
      },
    },
  ]

  const handleChange = (pagination) => {
    setpage(pagination.current)
    setpageSize(pagination.pageSize)
  }

  const style = {
    btnAddData: { borderRadius: '5px', width: '165px', height: '40px' },
    divSearch: {
      width: '100%',
      display: 'flex',
      gap: '20px',
      marginBottom: '20px',
    },
    btnSearch: { borderRadius: '5px', width: '136px', height: '40px' },
    inputSearch: { width: '100%', borderRadius: '6px', height: '40px' },
  }

  return (
    ///`${page}`
    <>
      <Fetch fetch={fetch} params={{ page, pageSize, shopName }} ref={fetchRef}>
        {({ data, total }) => (
          <>
            <PageLayout
              title={
                data.length > 0
                  ? `${data[0].reward.no} ${shopName} ${data[0].reward.shortDesc}`
                  : `ไม่พบข้อมูล`
              }
              shownBack={false}
            >
              <div style={style.divSearch}>
                <Input placeholder="" style={style.inputSearch} />

                <Button
                  style={style.btnSearch}
                  type="primary"
                  key="reload"
                  onClick={{}}
                >
                  {t('rewards.list.search')}
                </Button>
              </div>

              <Table
                rowKey="id"
                columns={columns}
                dataSource={data}
                onChange={handleChange}
                pagination={{
                  defaultCurrent: defaultPageSize,
                  defaultPageSize: defaultPageSize,
                  current: page,
                  pageSize,
                  total,
                }}
              ></Table>
            </PageLayout>
          </>
        )}
      </Fetch>
      {/* <Create
        modalCreateOpen={modalCreateOpen}
        setModalCreateOpen={setModalCreateOpen}
      />
      <Edit
        modalEditOpen={modalEditOpen}
        setModalEditOpen={setModalEditOpen}
        // dataSpecialEvent={dataSpecialEvent}
      /> */}
    </>
  )
}

export default CodeDetail
